<script>
    /**
     * Alert
     */
    export default {
        name: 'modal-footer',
        props: {
        },
        methods: {
            onDestroy () {
                this.$emit('close');
                this.$parent.close();
            }
        },
        mounted () {

        }
    };
</script>

<template>
    <div class="modal-footer">
        <slot></slot>
    </div>
</template>

<style lang="less" scoped>
    @import '../../assets/less/widgets-var.less';

    .modal-footer {
        height: 60px;
        width: 100%;
        box-sizing: border-box;
        padding: 0 30px;
        border-top: 1px solid @otherBorderClr;
        position: absolute;
        bottom: 0;
        background-color: #fff;
        left: 0;

        * {
            box-sizing: border-box;
        }

        > * {
            margin-top: 0;
            margin-bottom: 0;
        }

    }
</style>
